import React from "react";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="search-footer" role="contentinfo">
      <div className="l-search-footer">
        <div><a className="footer-link link fz13" href="how-search-works.html">{/*How search works*/}</a></div>
        <div className="footer-links">
          <a className="footer-link link fz13" href={`https://${process.env.REACT_APP_CMAP_HOME_DOMAIN}/privacy-policy`}>{t('footer.privacy')}</a>&nbsp;
          <a className="footer-link link fz13" href={`https://${process.env.REACT_APP_CMAP_HOME_DOMAIN}/terms-and-conditions`}>{t('footer.terms')}</a>
        </div>
        <div className="copyright"><span className="fz13 quiet">{t('footer.copyright', { year: currentYear })}</span></div>
      </div>
    </footer>
  );
}
